import $http from './index'

const getWinxinInfo = (data = {}) => $http.get('https://dict.youdao.com/imapi/wxauth', data)

export default {
  getWinxinInfo,
}
